import Context from './TranslateContext';
import Provider from './TranslateProvider';

export default {
  Consumer: Context.Consumer,
  Context,
  Provider,
};
